/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Row, Col, Checkbox } from "antd";
import { useSelector } from "react-redux";
import { convertToRGBAString } from "utils/helperFunctions";
import { fontSize } from "utils/CONSTANTS";

//@ts-ignore
const MultiSelectFormItem = React.memo(
  ({ component, item, selectedLanguage, form }) => {
    const {
      label = {},
      placeholder = {},
      select = [],
      name,
      label_bg_color = [255, 255, 255, 1],
      label_text_color = [117, 117, 117, 1],
      label_text_size = "S",
    } = item;

    const [selected, setSelected] = useState(null);
    const { formValues, isRTL } = useSelector((state) => state);

    let useFormFieldValue = null;
    if (component === "customer_data") {
      const { [item.name]: value = null } = form.getFieldValue(component) || {};
      useFormFieldValue = value;
    } else {
      const { [item.name]: value = null } = form.getFieldsValue() || {};
      useFormFieldValue = value;
    }

    useEffect(() => {
      if (useFormFieldValue) {
        const newSelectedValue = Array.isArray(useFormFieldValue)
          ? useFormFieldValue || null
          : null;
        setSelected(newSelectedValue);
      }
    }, [useFormFieldValue]);

    useEffect(() => {
      let formFieldValue = null;
      if (component === "customer_data") {
        const { [name]: value = null } = formValues[component] || {};
        formFieldValue = value;
      } else {
        const { [name]: value = null } = formValues || {};
        formFieldValue = value;
      }
      if (useFormFieldValue) {
        setSelected(formFieldValue);
      }
    }, []);

    const onChange = (values) => {
      if (component === "customer_data") {
        form.setFieldsValue({
          customer_data: {
            [name]: values,
          },
        });
      } else {
        form.setFieldsValue({
          [name]: values,
        });
      }
      setSelected(values);
    };

    return (
      <Row className="form-item-card">
        <Col
          xs={24}
          className="form-item-card-header"
          style={{
            backgroundColor: convertToRGBAString(label_bg_color),
          }}
        >
          <div className="flex-items-row centered">
            <span
              className="font-helvetica-neue-medium"
              style={{
                fontSize: fontSize[label_text_size],
                color: convertToRGBAString(label_text_color),
                textAlign: "center",
              }}
            >
              {placeholder[selectedLanguage]}
            </span>
          </div>
        </Col>
        {label_bg_color.every(
          (val, index) => val === [255, 255, 255, 1][index]
        ) && (
          <Col xs={24} style={{ height: "1px" }}>
            {/* <div className="twelve" /> */}
            <hr className="twelve" />
          </Col>
        )}
        <Col xs={24} className="form-item-card-body">
          <Checkbox.Group
            style={{
              width: "100%",
              // fontWeight: 500,
            }}
            value={selected || null}
            onChange={onChange}
          >
            {select.map((item, index) => (
              <Checkbox
                key={index}
                value={item.id}
                className={`multi-select-checkbox-holder form-font ${
                  isRTL && "component-right-to-left"
                } ${
                  selected && selected?.some((id) => id == item.id) && "checked"
                }`}
                style={{ fontSize: 16 }}
              >
                {item.option[selectedLanguage]}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </Col>
      </Row>
    );
  }
);

export default MultiSelectFormItem;
